/**
 * A Stripe payment method (as the TradMarket API lists it) in Sharetribe's
 * stripePaymentMethod shape, which the payment method UI reads. Null when there is none.
 */
export const transformPaymentMethod = stripePaymentMethod => {
  if (!stripePaymentMethod) return null;

  return {
    id: stripePaymentMethod.id,
    type: 'stripePaymentMethod',
    attributes: {
      type: 'stripe-payment-method/card',
      stripePaymentMethodId: stripePaymentMethod.id,
      card: {
        brand: stripePaymentMethod.card?.brand,
        last4Digits: stripePaymentMethod.card?.last4,
        expirationMonth: stripePaymentMethod.card?.exp_month,
        expirationYear: stripePaymentMethod.card?.exp_year,
      },
    },
  };
};
